var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollhouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35355 2.93934C8.63486 2.65804 9.01639 2.5 9.41422 2.5H20.5C21.0523 2.5 21.5 2.94772 21.5 3.5V14.5858C21.5 14.9836 21.342 15.3651 21.0607 15.6464L15.6464 21.0607C15.3651 21.342 14.9836 21.5 14.5858 21.5H3.5C2.94772 21.5 2.5 21.0523 2.5 20.5V9.41421C2.5 9.01639 2.65804 8.63486 2.93934 8.35355L8.35355 2.93934ZM19.7929 3.5H9.5V8.5H14.7929L19.7929 3.5ZM14.5 9.5H9.5V14.5H14.5V9.5ZM14.5 15.5H9.20711L4.20711 20.5H14.5V15.5ZM15.5 19.7929V15.5H19.7929L15.5 19.7929ZM20.5 14.5H15.5V9.20711L20.5 4.20711V14.5ZM3.5 19.7929V9.5H8.5V14.7929L3.5 19.7929ZM8.5 8.5V4.20711L4.20711 8.5H8.5Z",
    fill: "#2C2E4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollhouse);
export default __webpack_public_path__ + "static/media/dollhouse.db89bbbd332996c17f351e917c34500c.svg";
export { ForwardRef as ReactComponent };